import CenterSpinner from '@otovo/shared/components/LoadingScreens/CenterSpinner';
import MetaTags from '@otovo/shared/components/Sanity/MetaTags';
import { Sanity$BlogPage } from '@otovo/shared/types/sanityTypes';
import parse from 'html-react-parser';
import Head from 'next/head';
import { useRouter } from 'next/router';
import BlogTableOfContents from './BlogTableOfContents';
import FeaturedBlogPost from './FeaturedPost';
import { usePostJsonLd } from './usePostJsonLd';

type Props = {
  sanityDocument: Sanity$BlogPage;
};

const BlogPage = ({ sanityDocument }: Props) => {
  const router = useRouter();
  const postJsonld = usePostJsonLd(sanityDocument);

  if (router.isFallback) {
    return <CenterSpinner />;
  }

  return (
    <>
      {sanityDocument.codeInjection && (
        <Head>{parse(sanityDocument.codeInjection)}</Head>
      )}
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(postJsonld) }}
        />
      </Head>
      <MetaTags
        meta={sanityDocument.meta}
        defaultTags={{
          title: sanityDocument.title,
          description: '',
        }}
      />
      <div className="color-scheme-dark lg:color-scheme-light bg-surface">
        <FeaturedBlogPost featuredPost={sanityDocument} />
      </div>
      <div className="prose prose-lg mb-36 px-6 md:mx-auto lg:px-12 lg:py-6">
        <div className="mb-12">
          <BlogTableOfContents sanityDocument={sanityDocument} />
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: sanityDocument.content.code }}
        />
      </div>
    </>
  );
};

export default BlogPage;
